const loginActionTypes = {
  USER_LOGIN_TIME_CHANGED: "user_login_time_changed",
  USER_AUTH_CHECK_DONE_CHANGED: "user_auth_check_done_changed",

  /***************  USER LOGIN START  ******************/
  USER_SIGN_IN_START: "user_sign_in_start",
  USER_SIGN_IN_SUCCESS: "user_sign_in_success",
  USER_SIGN_IN_FAILURE: "user_sign_in_failure",
  USER_SIGN_IN_RESPONSE_RESET_START: "user_sign_in_response_reset_start",
  USER_SIGN_IN_RESPONSE_CHANGED: "user_sign_in_response_changed",
  /***************  USER LOGIN END  ******************/

  USER_SIGN_OUT_START: "user_sign_out_start",
  USER_SIGN_OUT: "user_sign_out",

  /*****************  USER AUTH VERIFY START  *******************/
  USER_AUTH_VERIFY_START: "user_auth_verify_start",
  USER_AUTH_VERIFY_SUCCESS: "user_auth_verify_success",
  USER_AUTH_VERIFY_FAILURE: "user_auth_verify_failure",
  USER_AUTH_VERIFY_RESPONSE_RESET_START:
    "user_auth_verify_response_reset_start",
  USER_AUTH_VERIFY_RESPONSE_CHANGED: "user_auth_verify_response_changed",
  /***************** 	USER AUTH VERIFY END  *****************/

  /*****************  FORGOT PASSWORD START  *******************/
  FETCH_FORGOT_PASSWORD_START: "fetch_forgot_password_start",
  FETCH_FORGOT_PASSWORD_SUCCESS: "fetch_forgot_password_success",
  FETCH_FORGOT_PASSWORD_FAILURE: "fetch_forgot_password_failure",
  FETCH_FORGOT_PASSWORD_RESPONSE_RESET_START:
    "fetch_forgot_password_response_reset_start",
  FETCH_FORGOT_PASSWORD_RESPONSE_CHANGED:
    "fetch_forgot_password_response_changed",
  /***************** 	FORGOT PASSWORD END  *****************/

  /*****************  UPDATE LOGIN USER PASSWORD START  *******************/
  UPDATE_USER_PASSWORD_START: "update_user_password_start",
  UPDATE_USER_PASSWORD_SUCCESS: "update_user_password_success",
  UPDATE_USER_PASSWORD_FAILURE: "update_user_password_failure",
  UPDATE_USER_PASSWORD_RESPONSE_RESET_START:
    "update_user_password_response_reset_start",
  UPDATE_USER_PASSWORD_RESPONSE_CHANGED:
    "update_user_password_response_changed",
  /***************** 	UPDATE LOGIN USER PASSWORD END  *****************/

  /** ***************** GET USER COMPANY DETAILS START *********************** */
  FETCH_USER_COMPANY_DETAILS_START: "fetch_user_company_details_start",
  FETCH_USER_COMPANY_DETAILS_SUCCESS: "fetch_user_company_details_success",
  FETCH_USER_COMPANY_DETAILS_FAILURE: "fetch_user_company_details_failure",
  FETCH_USER_COMPANY_DETAILS_RESPONSE_RESET_START:
    "fetch_user_company_details_response_reset_start",
  FETCH_USER_COMPANY_DETAILS_RESPONSE_CHANGED:
    "fetch_user_company_details_response_changed",
  /** ***************** GET USER COMPANY DETAILS END *********************** */

  /** ***************** 2FA (TOTP) LOGIN *********************** */
  USER_TOTP_REQUIRED: "user_totp_required",
  USER_TOTP_RESET: "user_totp_reset",

  /** Live RBAC grant refresh — patch userAccessData without a re-login. */
  UPDATE_USER_ACCESS_DATA: "update_user_access_data",
};
export default loginActionTypes;
